/* ================= ANGAR COLORI — theme JS ================= */
(function () {
  'use strict';

  var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var locale = document.documentElement.lang || 'it-IT';
  var currency = document.body.dataset.currency || 'EUR';

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '€ ' + ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',');
    }
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function setBodyLock() {
    var drawerOpen = document.querySelector('[data-cart-drawer].is-open');
    var menuOpen = document.querySelector('[data-mobile-menu].is-open');
    var filterOpen = document.querySelector('[data-mobile-filter][open]');
    document.body.classList.toggle('is-locked', Boolean(drawerOpen || menuOpen || filterOpen));
  }

  /* ---- Sticky header ---- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Mobile menu ---- */
  var burger = document.querySelector('[data-burger]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');

  function closeMobileMenu() {
    if (!burger || !mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    setBodyLock();
  }

  if (burger && mobileMenu) {
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-controls', 'MobileMenu');
    mobileMenu.id = mobileMenu.id || 'MobileMenu';

    burger.addEventListener('click', function () {
      var willOpen = !mobileMenu.classList.contains('is-open');
      mobileMenu.classList.toggle('is-open', willOpen);
      burger.setAttribute('aria-expanded', String(willOpen));
      setBodyLock();
    });

    mobileMenu.addEventListener('click', function (event) {
      if (event.target.closest('a')) closeMobileMenu();
    });
  }

  /* ---- Scroll reveal ---- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px 80px' });
    reveals.forEach(function (element) { revealObserver.observe(element); });
  } else {
    reveals.forEach(function (element) { element.classList.add('in'); });
  }

  /* ================= CART DRAWER ================= */
  var overlay = document.querySelector('[data-cart-overlay]');
  var drawer = document.querySelector('[data-cart-drawer]');
  var itemsElement = document.querySelector('[data-cart-items]');
  var footerElement = document.querySelector('[data-cart-foot]');
  var countElements = document.querySelectorAll('[data-cart-count]');
  var lastFocusedElement = null;

  function openDrawer() {
    if (!drawer || !overlay) return;
    lastFocusedElement = document.activeElement;
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    setBodyLock();
    var closeButton = drawer.querySelector('[data-cart-close]');
    if (closeButton) closeButton.focus();
  }

  function closeDrawer() {
    if (overlay) overlay.classList.remove('is-open');
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
    setBodyLock();
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') lastFocusedElement.focus();
  }

  if (drawer) {
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
  }

  function renderCart(cart) {
    countElements.forEach(function (counter) {
      counter.textContent = cart.item_count;
      counter.style.display = cart.item_count > 0 ? '' : 'none';
    });

    if (!itemsElement) return;

    if (cart.item_count === 0) {
      itemsElement.innerHTML = '<div class="drawer__empty"><p>Il carrello è vuoto.<br>Aggiungi i prodotti dal catalogo.</p></div>';
      if (footerElement) footerElement.style.display = 'none';
      return;
    }

    if (footerElement) footerElement.style.display = '';

    itemsElement.innerHTML = cart.items.map(function (item) {
      var title = escapeHtml(item.product_title);
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p style="font-size:11px;opacity:.55;margin:3px 0 0">' + escapeHtml(item.variant_title) + '</p>' : '';
      var imageSeparator = item.image && item.image.indexOf('?') > -1 ? '&' : '?';
      var image = item.image
        ? '<img src="' + escapeHtml(item.image) + imageSeparator + 'width=160" alt="' + title + '" loading="lazy">'
        : '<div class="cart-line__ph" style="height:64px;width:64px;display:grid;place-items:center;background:var(--paper-2);border-radius:8px;font-family:Bricolage Grotesque;font-weight:800;color:var(--olive)">' + title.charAt(0) + '</div>';

      return '<div class="cart-line" data-key="' + escapeHtml(item.key) + '">' +
        image +
        '<div style="flex:1;min-width:0">' +
          '<a href="' + escapeHtml(item.url) + '" style="display:block;font-weight:700;font-size:14px;line-height:1.2">' + title + '</a>' +
          variant +
          '<p style="font-size:12px;opacity:.6;margin:3px 0 0">' + formatMoney(item.final_price) + '</p>' +
          '<div class="qty" style="margin-top:8px;width:fit-content;padding:4px 8px">' +
            '<button type="button" data-qty-change data-key="' + escapeHtml(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Riduci quantità">−</button>' +
            '<span style="min-width:22px;text-align:center;font-weight:600">' + item.quantity + '</span>' +
            '<button type="button" data-qty-change data-key="' + escapeHtml(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Aumenta quantità">+</button>' +
            '<button type="button" data-qty-change data-key="' + escapeHtml(item.key) + '" data-qty="0" style="margin-left:8px;opacity:.5" aria-label="Rimuovi prodotto">✕</button>' +
          '</div>' +
        '</div>' +
        '<div class="price">' + formatMoney(item.final_line_price) + '</div>' +
      '</div>';
    }).join('');

    var totalElement = document.querySelector('[data-cart-total]');
    if (totalElement) totalElement.textContent = formatMoney(cart.total_price);
  }

  function jsonRequest(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || 'Si è verificato un errore.');
        return data;
      });
    });
  }

  function fetchCart() {
    return jsonRequest(rootPath + 'cart.js').then(renderCart);
  }

  function changeQuantity(key, quantity) {
    return jsonRequest(rootPath + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(renderCart);
  }

  function addToCart(id, quantity, trigger) {
    if (!id) return Promise.reject(new Error('Seleziona una variante disponibile.'));
    if (trigger) {
      trigger.classList.add('is-loading');
      trigger.disabled = true;
    }

    return jsonRequest(rootPath + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Math.max(1, Number(quantity) || 1) }] })
    }).then(function () {
      return fetchCart();
    }).then(function () {
      openDrawer();
    }).finally(function () {
      if (trigger) {
        trigger.classList.remove('is-loading');
        trigger.disabled = false;
      }
    });
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-cart-open]');
    if (openButton) {
      event.preventDefault();
      fetchCart().then(openDrawer).catch(openDrawer);
      return;
    }

    var closeButton = event.target.closest('[data-cart-close]');
    if (closeButton || event.target.hasAttribute('data-cart-overlay')) {
      closeDrawer();
      return;
    }

    var quickAdd = event.target.closest('[data-add-id]');
    if (quickAdd) {
      event.preventDefault();
      addToCart(quickAdd.getAttribute('data-add-id'), 1, quickAdd).catch(function (error) {
        window.alert(error.message);
      });
      return;
    }

    var quantityButton = event.target.closest('[data-qty-change]');
    if (quantityButton) {
      event.preventDefault();
      changeQuantity(quantityButton.getAttribute('data-key'), parseInt(quantityButton.getAttribute('data-qty'), 10)).catch(function (error) {
        window.alert(error.message);
      });
    }
  });

  /* ---- Collection sorting ---- */
  document.querySelectorAll('[data-collection-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  });

  /* ---- Mobile collection filters ---- */
  document.querySelectorAll('[data-mobile-filter]').forEach(function (details) {
    details.addEventListener('toggle', setBodyLock);
    var closeButton = details.querySelector('[data-close-filter]');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        details.removeAttribute('open');
        setBodyLock();
      });
    }
  });

  /* ================= PRODUCT PAGE ================= */
  document.querySelectorAll('[data-product-root]').forEach(function (productRoot) {
    var variantsElement = productRoot.querySelector('[data-product-variants]');
    if (!variantsElement) return;

    var variants;
    try {
      variants = JSON.parse(variantsElement.textContent);
    } catch (error) {
      return;
    }

    var form = productRoot.querySelector('[data-product-form]');
    var optionSelects = Array.prototype.slice.call(productRoot.querySelectorAll('[data-option-select]'));
    var idInput = productRoot.querySelector('[data-variant-id]');
    var submitButton = productRoot.querySelector('[data-product-submit]');
    var quantityInput = productRoot.querySelector('[data-qty-input]');
    var messageElement = productRoot.querySelector('[data-product-message]');
    var stickyButton = productRoot.querySelector('[data-sticky-submit]');
    var stickyPrice = productRoot.querySelector('[data-mobile-product-price]');
    var stickyBar = productRoot.querySelector('[data-mobile-product-bar]');
    var currentVariant = variants.find(function (variant) { return String(variant.id) === String(idInput && idInput.value); }) || variants[0];

    function showMedia(mediaId) {
      if (!mediaId) return;
      productRoot.querySelectorAll('[data-media-id]').forEach(function (media) {
        var active = String(media.dataset.mediaId) === String(mediaId);
        media.hidden = !active;
        media.classList.toggle('is-active', active);
      });
      productRoot.querySelectorAll('[data-media-thumb]').forEach(function (thumb) {
        var active = String(thumb.dataset.mediaThumb) === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', String(active));
        if (active) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      });
    }

    function selectedOptions() {
      return optionSelects
        .sort(function (a, b) { return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition); })
        .map(function (select) { return select.value; });
    }

    function findVariant() {
      var values = selectedOptions();
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) { return value === values[index]; });
      });
    }

    function updateVariant(variant, updateUrl) {
      currentVariant = variant || null;
      var available = Boolean(variant && variant.available);
      var price = variant ? variant.price : 0;
      var comparePrice = variant ? variant.compare_at_price : null;
      var onSale = Boolean(comparePrice && comparePrice > price);

      if (idInput) idInput.value = variant ? variant.id : '';

      var priceElement = productRoot.querySelector('[data-product-price]');
      var compareElement = productRoot.querySelector('[data-product-compare]');
      var saleElement = productRoot.querySelector('[data-product-sale]');
      var availabilityElement = productRoot.querySelector('[data-product-availability]');
      var skuElement = productRoot.querySelector('[data-product-sku]');

      if (priceElement) priceElement.textContent = variant ? formatMoney(price) : 'Non disponibile';
      if (stickyPrice) stickyPrice.textContent = variant ? formatMoney(price) : '—';
      if (compareElement) {
        compareElement.hidden = !onSale;
        compareElement.textContent = onSale ? formatMoney(comparePrice) : '';
      }
      if (saleElement) saleElement.hidden = !onSale;

      if (availabilityElement) {
        availabilityElement.classList.toggle('is-available', available);
        availabilityElement.innerHTML = '<i></i>' + (available ? 'Disponibile' : 'Esaurito');
      }

      if (skuElement) {
        skuElement.hidden = !(variant && variant.sku);
        skuElement.textContent = variant && variant.sku ? 'SKU: ' + variant.sku : '';
      }

      if (submitButton) {
        submitButton.disabled = !available;
        submitButton.textContent = available ? submitButton.dataset.availableLabel : submitButton.dataset.soldoutLabel;
      }

      if (stickyButton) {
        stickyButton.disabled = !available;
        stickyButton.textContent = available ? 'Aggiungi' : 'Esaurito';
      }

      var dynamicCheckout = productRoot.querySelector('[data-dynamic-checkout]');
      if (dynamicCheckout) dynamicCheckout.hidden = !available;

      if (variant && variant.featured_media) showMedia(variant.featured_media.id);

      if (updateUrl && variant && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        updateVariant(findVariant(), true);
      });
    });

    productRoot.querySelectorAll('[data-media-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(thumb.dataset.mediaThumb); });
    });

    productRoot.querySelectorAll('[data-qty-inc]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (quantityInput) quantityInput.value = Math.max(1, (parseInt(quantityInput.value, 10) || 1) + 1);
      });
    });

    productRoot.querySelectorAll('[data-qty-dec]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (quantityInput) quantityInput.value = Math.max(1, (parseInt(quantityInput.value, 10) || 1) - 1);
      });
    });

    if (quantityInput) {
      quantityInput.addEventListener('change', function () {
        quantityInput.value = Math.max(1, parseInt(quantityInput.value, 10) || 1);
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!currentVariant || !currentVariant.available) return;
        if (messageElement) messageElement.hidden = true;

        addToCart(currentVariant.id, quantityInput ? quantityInput.value : 1, submitButton).catch(function (error) {
          if (messageElement) {
            messageElement.textContent = error.message;
            messageElement.hidden = false;
          }
          if (submitButton) submitButton.disabled = !currentVariant.available;
        });
      });
    }

    if (stickyButton && form) {
      stickyButton.addEventListener('click', function () { form.requestSubmit(); });
    }

    if (stickyBar && submitButton && 'IntersectionObserver' in window) {
      var purchaseObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY > 240);
        });
      }, { threshold: 0 });
      purchaseObserver.observe(submitButton);
    }

    updateVariant(currentVariant, false);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeDrawer();
    closeMobileMenu();
    document.querySelectorAll('[data-mobile-filter][open]').forEach(function (details) { details.removeAttribute('open'); });
    setBodyLock();
  });

  fetchCart().catch(function () { /* Cart remains progressively enhanced. */ });
})();
